module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "clearfix container",
    staticStyle: {
      "position": "relative"
    }
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "r nav-user-operate"
  }, [_c('li', [_c('a', {
    staticClass: "create-video",
    on: {
      "click": _vm.goPublish
    }
  }, [_c('i', {
    staticClass: "icon xj"
  }), _vm._v("我要拍片")])]), _vm._v(" "), (_vm.noUser) ? _c('li', [_c('a', {
    staticClass: "login",
    attrs: {
      "href": "register.html"
    }
  }, [_vm._v("登录")]), _vm._v("|"), _c('a', {
    staticClass: "register",
    attrs: {
      "href": "register.html"
    }
  }, [_vm._v("注册")])]) : _vm._e(), _vm._v(" "), (!_vm.noUser && Object.keys(_vm.userInfos).length > 0) ? _c('li', {
    staticClass: "userName",
    staticStyle: {
      "positive": "relative"
    },
    on: {
      "mouseover": _vm.overShow
    }
  }, [_c('img', {
    staticStyle: {
      "width": "40px",
      "height": "40px",
      "border-radius": "50%"
    },
    attrs: {
      "src": _vm.userInfos.data.faceUrl ? _vm.userInfos.data.faceUrl : _vm.defaultUrl,
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userInfos.hasMsg == 1),
      expression: "userInfos.hasMsg == 1"
    }],
    staticStyle: {
      "width": "5px",
      "height": "5px",
      "border-radius": "5px",
      "background-color": "red",
      "display": "block",
      "position": "absolute",
      "right": "5px",
      "top": "13px"
    }
  })]) : _vm._e()]), _vm._v(" "), (!_vm.noUser && Object.keys(_vm.userInfos).length > 0) ? _c('div', {
    staticClass: "person-index",
    class: {
      'person-show': _vm.personIndex === true
    },
    staticStyle: {
      "width": "180px",
      "height": "auto"
    },
    on: {
      "mouseleave": _vm.outHide
    }
  }, [_c('ul', [_c('li', {
    staticStyle: {
      "positive": "relative"
    }
  }, [_c('a', {
    attrs: {
      "href": "inform.html"
    }
  }, [_vm._v("消息")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userInfos.hasMsg == 1),
      expression: "userInfos.hasMsg == 1"
    }],
    staticStyle: {
      "width": "5px",
      "height": "5px",
      "border-radius": "5px",
      "background-color": "red",
      "display": "block",
      "position": "absolute",
      "right": "20px",
      "top": "20px"
    }
  })]), _vm._v(" "), (_vm.userInfos.data.producerType != 3) ? _c('li', [_c('a', {
    attrs: {
      "href": 'userPage.html?id=' + _vm.userInfos.data.id + '&origin=1',
      "target": "_blank"
    }
  }, [_vm._v("制作人中心")])]) : _vm._e(), _vm._v(" "), (_vm.userInfos.data.producerType == 3) ? _c('li', [_c('a', {
    attrs: {
      "href": 'talentActor.html?id=' + _vm.userInfos.data.id + '&origin=1',
      "target": "_blank"
    }
  }, [_vm._v("制作人中心")])]) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), (_vm.userInfos.data.isProducer === 1) ? _c('li', [_c('a', {
    attrs: {
      "href": "person.html"
    }
  }, [_vm._v("钱包")])]) : _vm._e(), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("退出登录")])])])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "l nav-menu"
  }, [_c('li', [_c('h1', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "111px"
    },
    attrs: {
      "src": require("../assets/images/logo.png")
    }
  })])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("首页")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "valuer.html",
      "target": "_blank"
    }
  }, [_vm._v("拍片估价")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "case.html"
    }
  }, [_vm._v("案例展示")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "talent.html"
    }
  }, [_vm._v("行业资源")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "newsList.html"
    }
  }, [_vm._v("新闻资讯")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "about.html"
    }
  }, [_vm._v("关于我们")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "project.html"
    }
  }, [_vm._v("我的项目")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "collectionList.html"
    }
  }, [_vm._v("我的收藏")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "account.html"
    }
  }, [_vm._v("账号设置")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b3a8cab2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 25
// module chunks = 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44